import React from 'react';

const SocialProofSection = () => {
  return (
    <section className="bg-[#191919] py-[50px] px-[25px] md:py-[75px] md:px-[75px] lg:py-[100px] lg:px-[100px]">
      <div className="max-w-5xl mx-auto">
        {/* Main Headline */}
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-[#F8F8F8] text-center mb-8 tracking-tight leading-tight">
          Fira Tak Nak Tunjuk <span className="text-[#FF6699]">Screenshot Profit.</span>
        </h2>

        {/* Reasons */}
        <div className="text-center space-y-4 mb-12">
          <p className="text-xl md:text-2xl text-[#F8F8F8]/70 font-medium">
            Sebab senang nak fake.
          </p>
          <p className="text-xl md:text-2xl text-[#F8F8F8]/70 font-medium">
            Sebab profit hari ni boleh jadi loss esok.
          </p>
          <p className="text-xl md:text-2xl text-[#F8F8F8]/70 font-medium">
            Sebab screenshot tak cerita full story.
          </p>
        </div>

        {/* Transition */}
        <div className="text-center mb-16">
          <p className="text-2xl md:text-3xl text-[#FF6699] font-bold">
            Fira nak tunjuk benda lain:
          </p>
        </div>

        {/* Divider */}
        <div className="flex justify-center mb-16">
          <div className="w-32 h-1 bg-[#FF6699]" />
        </div>

        {/* Feature 1: 500+ Traders - With Border - Center Aligned */}
        <div className="mb-12 border-2 border-[#F8F8F8]/10 rounded-3xl p-6 md:p-10 lg:p-12 hover:border-[#FF6699]/30 transition-all duration-300">
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#F8F8F8] text-center mb-12 tracking-tight">
            <span className="text-[#33CCCC]">500+</span> Traders Masih Guna Sampai Hari Ini.
          </h3>
          
          <div className="flex flex-col items-center gap-8 md:gap-12">
            {/* Phone Mockup - Overview CROP - Bottom padding 0 */}
            <div className="flex justify-center">
              <div className="border-2 border-[#F8F8F8]/10 rounded-3xl pt-4 px-4 pb-0 bg-[#F8F8F8]/5 overflow-hidden">
                <img 
                  src="https://customer-assets.emergentagent.com/job_618cd302-26c2-4845-b940-fc1c769b2643/artifacts/f5ebdua0_OVERVIEW-CROP.png"
                  alt="Overview Smart Desk"
                  className="w-full max-w-[280px] md:max-w-[320px] h-auto object-contain"
                />
              </div>
            </div>

            {/* Content - Center Aligned */}
            <div className="space-y-6 text-center">
              <p className="text-xl md:text-2xl text-[#F8F8F8]/70 font-medium">
                Bukan "500 orang pernah download."
              </p>
              <p className="text-2xl md:text-3xl text-[#F8F8F8] font-bold">
                Tapi <span className="text-[#33CCCC]">500 orang yang stay.</span>
              </p>
              
              <div className="pt-6 space-y-4">
                <p className="text-lg md:text-xl text-[#F8F8F8]/70 font-medium">
                  Diorang stay bukan sebab Fira perfect.
                </p>
                <p className="text-xl md:text-2xl text-[#FF6699] font-bold">
                  Diorang stay sebab Fira useful.
                </p>
              </div>

              <p className="text-lg md:text-xl text-[#F8F8F8]/50 font-medium pt-4">
                Ada beza.
              </p>
            </div>
          </div>
        </div>

        {/* Feature 2: Win Rate - With Border - Center Aligned */}
        <div className="border-2 border-[#F8F8F8]/10 rounded-3xl p-6 md:p-10 lg:p-12 hover:border-[#FF6699]/30 transition-all duration-300">
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#F8F8F8] text-center mb-12 tracking-tight">
            Win Rate <span className="text-[#33CCCC]">79.8%</span>? Ya. Tapi...
          </h3>
          
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-xl md:text-2xl text-[#F8F8F8]/80 font-medium mb-8">
              Itu based on signal yang dikeluarkan.
            </p>
            <p className="text-2xl md:text-3xl text-[#FF6699] font-bold mb-12">
              Bukan based on anda punya execution.
            </p>

            <p className="text-xl md:text-2xl text-[#F8F8F8]/80 font-medium mb-6">
              Kalau anda:
            </p>

            {/* Warning List - Center Aligned */}
            <div className="space-y-4 mb-12">
              <div className="flex items-center gap-3 justify-center">
                <div className="w-2 h-2 bg-[#FF6699] rounded-full flex-shrink-0" />
                <p className="text-lg md:text-xl text-[#F8F8F8]/70 font-medium">Tak follow risk management</p>
              </div>
              <div className="flex items-center gap-3 justify-center">
                <div className="w-2 h-2 bg-[#FF6699] rounded-full flex-shrink-0" />
                <p className="text-lg md:text-xl text-[#F8F8F8]/70 font-medium">Entry lambat sebab hesitate</p>
              </div>
              <div className="flex items-center gap-3 justify-center">
                <div className="w-2 h-2 bg-[#FF6699] rounded-full flex-shrink-0" />
                <p className="text-lg md:text-xl text-[#F8F8F8]/70 font-medium">Exit awal sebab takut</p>
              </div>
              <div className="flex items-center gap-3 justify-center">
                <div className="w-2 h-2 bg-[#FF6699] rounded-full flex-shrink-0" />
                <p className="text-lg md:text-xl text-[#F8F8F8]/70 font-medium">Revenge trade lepas loss</p>
              </div>
            </div>

            <p className="text-2xl md:text-3xl text-[#FFD760] font-bold mb-8">
              Win rate anda akan lain.
            </p>

            <div className="bg-[#F8F8F8]/5 rounded-2xl p-6 md:p-8 mb-8">
              <p className="text-xl md:text-2xl text-[#F8F8F8] font-bold">
                Tool sama. Result berbeza. Sebab trader berbeza.
              </p>
            </div>

            <p className="text-lg md:text-xl text-[#F8F8F8]/80 font-medium">
              I nak anda faham ni <span className="text-[#FF6699] font-bold">sebelum</span> anda join.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
